export class RatedAssets
{
    public assetId: string;
    public assetVersion: String;
}